import React from 'react';
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react"
import { apiEndpoint } from "helpers/url_helper";


import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  FormGroup,
  Form,
  Button,
  UncontrolledTooltip,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,

} from "reactstrap"

import Switch from "react-switch"

import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";

import { useEffect } from 'react';
import { useState, createContext } from 'react';
import { setRef } from '@fullcalendar/react';
import { setBreadcrumbItems } from "../../store/actions";




//export const LatLongContext = createContext("67");


function AddSmtpConfiguration(props) {

  var EncodedCampus = '';
  var CampusImagePath = '';
  const [toggleSwitch, settoggleSwitch] = useState(true);
  const [toggleSwitchSize, settoggleSwitchSize] = useState(true);
  const [values, setValues] = useState([]);
  const selectedPlace = {}
  const [FormValues, setFormValues] = useState({ CampusID: '', CampusName: '', LocationName: '', ControllerIPAddress: '', CameraIPAddress: '', MacAddress: '' });
  const [modal_small, setmodal_small] = useState(false);
  const handleInput = (e) => {
    const { LocationName, value } = e.target;

    setFormValues({ ...FormValues, [LocationName]: value });
    console.log(FormValues);
  }

  const [NewSMTPHost, setNewSMTPHost] = useState();
  const [NewSMTPPort, setNewSMTPPort] = useState();
  const [NewSMTPEnableSSL, setNewSMTPEnableSSL] = useState();
  const [NewMailFrom, setMailFrom] = useState();
  const [NewPassword, setNewPassword]= useState();
  const [SelectedCampusValue, setSelectedCampusValue] = useState(1);
  const [EnableSSLSwitch, setEnableSSLSwitch] = useState(true);
  const [EnableEmailAlerts, setEnableEmailAlerts] = useState(true);
  const [EnableSMSAlerts, setEnableSMSAlerts] = useState(true);

 const [CampsuList, setCampusList] = useState([]);

 const [AddMessageResponse, setAddMessageResponse] = useState();  
 const [modalOpen, setModalOpen] = useState(false);
 const [basic, setbasic] = useState(false);




  //const LatContextValue = {NewLatitudeValue, setNewLatitudeValue}; 

  useEffect(()=>{
    props.setBreadcrumbItems('Email and SMS', breadcrumbItems);

  });

  const breadcrumbItems = [
    { title: "Settings", link: "#" },
    { title: "Email and SMS", link: "/addSmtpConfig" },
]

  const tog_small = () => {
    debugger;
    setmodal_small(!modal_small)
    document.body.classList.add("no_padding")
  }


  const Offsymbol = (props) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        No
      </div>
    )
  }
  
  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  useEffect(() => {
    debugger;
    // UserValidated
    fetch(apiEndpoint+"/CampusList",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify({
        "strToken": sessionStorage.getItem("Clear_AuthUser")
        
      })
  })
  .then(res => res.json())
  .then((data) => {
   debugger;
      setCampusList(data.CampusList);
      GetSmtpDetails(data.CampusList[0].CampusID);
      //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
      
  });
  
  },[]);
  
  const handleCampusChange = event => {
    debugger;
   
   
    setSelectedCampusValue(event.target.value);
    GetSmtpDetails(event.target.value);
  
  
    
  };

  const GetSmtpDetails = (CampusID) => {
 
    debugger;
    
    var intCampusID = CampusID;
    setSelectedCampusValue(intCampusID);
    // UserValidated
    fetch(apiEndpoint+"/GetSmtpConfigDetails",
    {
     method:"POST",
      headers: {
        'Content-Type': 'application/json',
       // 'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify({
        "intCampusID": intCampusID,
        "strToken": sessionStorage.getItem("Clear_AuthUser")
      })
  })
  .then(res => res.json())
  .then((data) => {
   debugger;
   
   if(data.SmtpConfigDetails != null){
    console.log("data---->", data);
        setNewSMTPHost(data.SmtpConfigDetails.HostName);
        setMailFrom(data.SmtpConfigDetails.MailFrom);
        setNewPassword(data.SmtpConfigDetails.Password);
        setNewSMTPPort(data.SmtpConfigDetails.PortNumber);
        setEnableEmailAlerts(data.SmtpConfigDetails.EnableEmail);
        setEnableSMSAlerts(data.SmtpConfigDetails.EnableSMS);
    
   
   }
   else{
    setNewSMTPHost("");
    setMailFrom("");
    setNewPassword("");
    setNewSMTPPort();
    setEnableEmailAlerts(false);
    setEnableSMSAlerts(false);

    
   }
     
  });
  
  };


  const SubmitNewSmtpDetails = () => {
    debugger;
    // UserValidated
    fetch(apiEndpoint+'/AddNewSmtpConfig',
      {
        mode: "cors",
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "intCampusID": SelectedCampusValue,
          "strHostName": NewSMTPHost,
          "intPortNumber": NewSMTPPort,
          "boolEnableSSL": EnableSSLSwitch,
          "strMailFrom": NewMailFrom,
          "strPassword": NewPassword,
          "boolEnableSMS": EnableSMSAlerts,
          "boolEnableEmail": EnableEmailAlerts,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
       
        


      }
      
    )
    .then(res => res.json())
      .then((data) => {
        debugger;
        console.log("Response Message:->", data);
        if(data.ResponseType == "Success")
        {
          setbasic(true);
          setAddMessageResponse(data.ResponseMessage);
        }
      })
  }

  


 



  return (
    <React.Fragment>
      

      {basic ? (
        <SweetAlert
          title={AddMessageResponse}

          onConfirm={() => {
            setbasic(false);
          }}
        />
      ) : null}


      <Row className="col-md-12">

        <Col className="col-md-12">
          <Card>
            <CardBody>
            <Row>
            <div className="col-md-6">
              <Row className="mb-3">
                <label
                  htmlFor="example-text-input"
                  className="col-md-4 col-form-label"
                >
                  Campus
                </label>

                <div className="col-md-8">

                       <select className="form-control" value={SelectedCampusValue} onChange={handleCampusChange} classNamePrefix="select2-selection"
                    >
                       { CampsuList.map(i => <option value={i.CampusID}>{i.CampusName}</option>
                         )}
                         
                        </select>
                    </div>
                

              </Row>
        { EnableEmailAlerts && <Col md-4>
          <Row className="mb-3">
           <label
             htmlFor="example-search-input"
             className="col-md-4 col-form-label"
           >
             SMTP Host Name
           </label>
           <div className="col-md-8">
             <input
               className="form-control"
               type="text"
               defaultValue={NewSMTPHost}
               onChange={(event) => {
                 setNewSMTPHost(event.target.value);
               }}
             />
           </div>
         </Row>
         <Row className="mb-3">
           <label
             htmlFor="example-email-input"
             className="col-md-4 col-form-label"
           >
             SMTP Port Number 
           </label>
           <div className="col-md-8">
             <input
               className="form-control"
               type="text"
               defaultValue={NewSMTPPort}
               onChange={(event) => {
                 setNewSMTPPort(event.target.value);
               }}

             />
           </div>
         </Row>

         <Row className="mb-3">
           <label
             htmlFor="example-email-input"
             className="col-md-4 col-form-label"
           >
            EMail From
           </label>
           <div className="col-md-8">
             <input
               className="form-control"
               type="text"
               defaultValue={NewMailFrom}
               onChange={(event) => {
                 setMailFrom(event.target.value);
               }}
             />
           </div>
         </Row>

         <Row className="mb-3">
           <label
             htmlFor="example-email-input"
             className="col-md-4 col-form-label"
           >
             Password
           </label>
           <div className="col-md-8">
             <input
               className="form-control"
               type="password"
               defaultValue={NewPassword}
               onChange={(event) => {
                 setNewPassword(event.target.value);
               }}
             />
           </div>
         </Row>
         <Row className="mb-3">
          <div className="col-md-4">
          
          </div>
          <div className="col-md-4">
          <label
             htmlFor="example-email-input"
             className="col-md-6 col-form-label"
           >
             Enable SSL
           </label>
           <div className="col-md-2">
           <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  onChange={() => {
                    setEnableSSLSwitch(!EnableSSLSwitch)
                  }}
                  checked={EnableSSLSwitch}
                />
           </div>
          </div>
          </Row>
        </Col>  
        }     
           


         
        
         </div>
         <div className="col-md-6">
         <Row className="mb-3">
          
          <div className="col-md-12">
          <label
             htmlFor="example-email-input"
             className="col-md-4 col-form-label"
           >
             Enable Email Alert
           </label>
          
           <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  onChange={() => {
                    setEnableEmailAlerts(!EnableEmailAlerts)
                  }}
                  checked={EnableEmailAlerts}
                />
          </div>
         
          
         </Row>

         <Row className="mb-3">
          
          <div className="col-md-12">
          <label
             htmlFor="example-email-input"
             className="col-md-4 col-form-label"
           >
             Enable SMS Alert
           </label>
          
           <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  onChange={() => {
                    setEnableSMSAlerts(!EnableSMSAlerts)
                  }}
                  checked={EnableSMSAlerts}
                />
          </div>
         
          
         </Row>



         </div>
      

              </Row>
              <Row>

                <div className="col-md-6 offset-2">
                  <button type="submit" className="btn btn-primary w-md" onClick={SubmitNewSmtpDetails}>Submit</button>
                </div>
              </Row>



            </CardBody>
          </Card>
        </Col>
        
      </Row>




    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems }) (AddSmtpConfiguration) ; 